import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { GeneralReport } from './../../../../documents';

@Component({
    selector: 'application-training-info',
    template: require('./application-training-info.component.html'),
    styles: [require('./document-info.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApplicationTrainingInfoComponent  {

    @Input()
    public report: GeneralReport;    

    public get rolesString() {
        return this.report.audienceRoles.join(', ');
    }   
}